// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../svg/star_filled.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General */
* {
  box-sizing: border-box;
}

body {
  min-width: 360px;
  font-family: 'Open Sans';
}

h1 {
  font-size: 2rem;
  margin-top: 2rem !important;
  padding-right: 0.5rem;
}

h2 {
  font-size: 1rem;
}

h4 {
  margin-top: 1rem !important;
}

h5 {
  font-size: 2.5rem;
  margin-top: 1rem !important;
}

ul {
  list-style-type: none;
  padding-left: 0px
}

img {
  margin: 2rem 0px;
}

/* Application mobile first */

.app {
  width: 100%;
  height: 100%;
}

#root {
  position: relative;
  min-height: 100vh;
  overflow-x: scroll;
}

.main-view {
  min-height: 100%;
  margin: 1rem 1rem 6rem 1rem;
}

#content-wrap {
  width: 100%;
  padding-bottom: 5rem;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 5rem;
  z-index: -1;
  text-align: center;
  background-color: #eee;
  padding: 1.8rem;
}

.error-container {
  margin: 2rem 2rem;
}

.header-name {
  margin-left: 1rem;
  font-size: x-large;
}

.header-name-logo-line {
  display: inline-flex;
}

.header-pepron-logo {
  width: 100px;
  height: auto;
  margin: 1rem;
}

.instruction-line {
  margin: 0.2rem;
  line-height: 1.5rem;
}

.layout-content {
  padding: 0;
  padding: 1rem 0.5rem 1rem 0.5rem;
}

.title-new-skill {
  display: inline-block;
}

.categories {
  padding: 3px;
}

.category {
  padding: 0;
  width: 100%;
  font-size: 1rem;
  background-color: #eee;
  border-radius: 5px;
  margin-bottom: 5px;
  border: solid 1px #ddd;
}

.category-content-visible {
  display: block;
}

.category-caption {
  cursor: pointer;

  display: flex;
  flex-direction: column;
  color: #161;
  padding: 0.5rem;
  background-color: #e8e8e8;
  /* background-image: linear-gradient(#fff,#ddd); */
  border-radius: 5px 5px 0 0;
}

/*  highlight with gradient on category selection */
.category-caption:hover {
  color: #0f6901;
  background-image: linear-gradient(#fff, #fff, #ddd);
}

.category-nename {
  flex-grow: 1;
  width: 50%;
  -webkit-user-select: none;
          user-select: none;
}

.category-levels {
  display: flex;
  justify-content: flex-end;
}

.category-selected-positioning {
  align-self: flex-end;
}

.category-selected-icon {
  line-height: 1.6rem;
  height: auto;
  width: 3rem;

  margin: 2px;

  border: 0px;
  border-radius: 1rem;
  border-style: solid;

  font-size: 1rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  -webkit-user-select: none;
          user-select: none;
}

.instruction-icon {
  border-color: #aaa;
  background-color: #bbb;
  box-shadow: 0px 5px 0px rgba(255, 255, 255, 0.3) inset;

  line-height: 1rem;
  width: 1.7rem;
  margin: 0.2rem;
  border: 0px;
  border-radius: 1rem;
  border-style: solid;

  font-size: 0.7rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  -webkit-user-select: none;
          user-select: none;
}

.category-level {
  display: inline-block;
}

.category-content-noncollapsed {
  height: auto;
}

.category-content-collapsed {
  height: 0;
  overflow: hidden;
}

.header {
  display: flow-root;
  position: relative;
}

.header-menu {
  width: 100%;
  margin: 1.5rem 2px 2px 2px;
}

p.find-consultants-grid-description {
  margin: 1em;
}

.lead-score-result {
  overflow-y: scroll; 
  min-height: 300px;
  height: fit-content;
  margin-bottom: 1rem;
  padding: 20px;
  border: #c6c6c6 solid 1px;
  border-radius: 2px;
}

.leads-view {
  margin: 0.5rem !important;
}

.leads-view .leads-dropdown {
  margin-bottom: 1rem;
}

.leads-selections .lead-links {
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  align-items: center;
}

.lead-links a {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
}

.candidate-results-container {
    margin-bottom: 0.5rem;
    align-content: start;
    height: fit-content;
}

.login-container {
  width: 50%;
  height: 50%;
  margin: auto;
}

.login-view {
  flex-direction: column;
  align-self: center;
  align-content: center;
  width: 100%;
  height: 100%;
  display: flex;
}

.login-button-container {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.no-skill-entries {
  margin: 1em;
}

.not-found {
  text-align: center;
  margin: 2rem;
}

/* Profile page */

.profile-view {
  padding-top: 2rem;
  display: flex;
  align-items: start;
  height: 30rem;
}

.profile-view > .ui.segment {
  width: 80%;
  margin: 0 auto;
}

.profile-view .ui.header {
  background-color: white;
}

.redirecting-spinner {
  height: 60px;
}

.score-for {
  display: flex;
  padding-bottom: 0.5rem;
}

.score-for:hover {
  background-color: rgb(239, 239, 239);
}

#score-for-list:last-child {
  margin-bottom: 30px;
}

.score-for .profile-name {
  width: 200px;
}

.score-for-profile-percentage {
  width: fit-content;
  min-width: 50px;
  text-align: center;
}

.score-for-links {
  width: 200px;
  text-align: start;
  margin-left: 1em;
}

.signin-button {
  margin: 2.5rem;
}

.skill {
  display: flex;
  align-items: center; /* This was added for items in the center */
  color: #000;
  font-size: 1rem;
  padding: 0.5rem;
  background-color: rgba(200, 200, 200, 0);
  transition: background-color 1s;
}

.skill:hover {
  background-image: linear-gradient(#fff, #fff, #ddd);
}

.skill-name {
  flex-grow: 1;
  -webkit-user-select: none;
          user-select: none;
}

.skill-buttons {
  display: flex;
  justify-content: space-between;
}

.error-message {
  width: 100% !important;
  z-index: 1000;
  position: fixed;
  top: 1rem;
  height: fit-content;
}

.personal-preference {
  margin: 4px 4px 4px 4px;
  line-height: 2rem;
}

.star {
  display: inline-block;
  height: 1rem;
  width: 1.7rem;
  margin: 1px;
  border: 0px;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1rem;
  background-repeat: no-repeat;
  background-position: center;

  opacity: 0.4;
}

.skills-save {
  display: block;
  width: 100%;
  border-radius: 5px;
  margin: 1rem 0;
  padding: 1rem;
  font-family: 'Open Sans';
  font-size: 1.5rem;
  background: #272;
  color: #fff;
  border: 0;
}

.saveskills:hover {
  background: #161;
}

.saved {
  background: #282;
}

.level--1 {
  background: #bbb;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5) inset;
}

.level-0 {
  background: rgb(92, 92, 92);
}

.level-1 {
  background: rgb(0, 40, 0);
}

.level-2 {
  background: rgb(14, 79, 10);
}

.level-3 {
  background: rgb(34, 119, 34);
}

.level-4 {
  background: rgb(20, 149, 14);
}

.level-5 {
  background: rgb(5, 187, 5);
}

.level-loading {
  background:#e1900d;
}

/* Colors for partially filled skills */
.level-0.grayscale {
  background: rgb(92, 92, 92);
}

.level-1.grayscale {
  background: rgb(45, 45, 45);
}

.level-2.grayscale {
  background: rgb(68, 68, 68);
}

.level-3.grayscale {
  background: rgb(87, 87, 87);
}

.level-4.grayscale {
  background: rgb(107, 107, 107);
}

.level-5.grayscale {
  background: rgb(139, 139, 139);
}

/* Overrides for react.semantic-ui */

/* General */
header > div.ui.menu {
  margin: auto 1rem auto 1rem;
}

button.ui.button.skill-level {
  margin: 2px;

  border: 0px;
  border-radius: 1rem;
  border-style: solid;
  border-color: #fff;
  box-shadow: 0px 5px 0px rgba(255, 255, 255, 0.3) inset;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/*  highlight background on empty selections */
button.ui.button.skill-level.level--1:hover {
  background-color: rgba(200, 200, 200, 0.5);
}

button.ui.button.skill-level.level--1 {
  background: #bbb;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5) inset;
}

button.ui.button.skill-level.level-0 {
  background: rgb(92, 92, 92);
}

button.ui.button.skill-level.level-1 {
  background: rgb(0, 40, 0);
}

button.ui.button.skill-level.level-2 {
  background: rgb(14, 79, 10);
}

button.ui.button.skill-level.level-3 {
  background: rgb(34, 119, 34);
}

button.ui.button.skill-level.level-4 {
  background: rgb(20, 149, 14);
}

button.ui.button.skill-level.level-5 {
  background: rgb(5, 187, 5);
}

button.ui.button.skill-level.level-error {
  background: #9f3a38;
}

button.ui.button.skill-level.level-loading {
  background: #e1900d;
}

div.ui.error.message.errorStatus {
  min-height: 150px;
  margin-top: 2em;
  padding: 2em;
}

.header .ui.dimmer {
  display: inline-block;
  z-index: 1000;
  position: fixed !important;
  /* left: 58% !important; */
  top: 20% !important;
  width: 100%;
  height: 80px;
  justify-items: end;
  background-color: #3f5d5172;
}

.header .ui.dimmer .ui.loader {
  align-content: space-around !important;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}

.header .ui.dimmer .ui.loader:after {
  border-color: rgba(25, 255, 25, 0.695) transparent transparent;
}

.ui.segment.instructions {
  font-size: 0.8rem;
  padding: 1rem;
  margin: 1rem 0.5rem 1rem 0.5rem;
  background-color: #fff;
  border: solid 1px #ddd;
}

.ui.button.dropdown {
 height: 2.5rem;
}

i.help {
 margin: 0px;
}

.filter-interactables {
  min-width: 140px;
  display: grid;
  grid-template-columns: 40% 60%;
  grid-template-rows: 40% auto;
  grid-template-areas:
    'checkbox subtitle'
    'dropdown dropdown';
  padding-bottom: 1rem;
  row-gap: 0.3rem;
}

.filter-interactables > .ui.fitter.toggle.checkbox {
  grid-area: checkbox;
}

.filter-interactables > .subtitle {
  grid-area: subtitle;
}

.filter-interactables > .dropdown {
  grid-area: dropdown;
}

.header-button-line {
  position: absolute;
  top: 1.5rem;
  right: 1rem;
  height: fit-content;
  text-align: left;
}

.ui.button.logout-button {
  display: inline-block;
  text-align: left;
  margin-left: 1rem;
  height: 3rem;
  /* padding: 10px 10px;
  border-style: solid;
  border-color: rgb(122, 122, 122);
  border-width: 1px;
  border-radius: 3px;  */
}

.help-button {
  padding: 11px 10px;
  text-align:  center;
  border-style: solid;
  border-color: rgb(122, 122, 122);
  border-width: 1px;
  border-radius: 3px;
}

/* Consultant profile*/
.consultant-wrapper {
  height: fit-content;
  margin-bottom: 30px;
}

.consultant-info {
  margin-left: 2rem;
  margin-bottom: 1rem;
}

.consultant-title {
  margin-left: 2rem;
  padding-top: 1rem;
}

.consultant-view .guideline {
  align-items: center;
  font-weight: bold;
  margin: 1rem;
}

.edit-button {
  width: max-content;
  max-height: max-content;
  margin: 1rem 0 0.5rem 1rem;
}

.edit-button .ui.active.button {
  box-shadow: 5px 5px 7px  #3b4532a5 !important;
}

.edit-mode {
   border-color: #c6c6c6;
   border-radius: 3px;
   box-shadow: 7px 7px 12px 7px #3b4532a5;
}

/* Screens overrides */
/* All mediatypes and if screen is wider than 985px */
@media all and (min-width: 985px) {

  .header {
    display: flex;
    flex-direction: row;
    align-content: center;
    width: 100%;
    height: auto;
    text-align: left;
    vertical-align: middle;
    background-color: #eee;
    padding: 2rem;
  }

  .header-interactables {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .header-menu {
    display: flex;
    align-items: center;
    width: 100%;
    margin: auto;
  }

  .header-name {
    margin: auto 2rem auto 0;
    font-size: x-large;
  }

  .header-button-line {
    top: 3rem;
  }

  .content-list {
    padding-inline-start: 0;
  }

  .category-caption {
    cursor: pointer;
  }

  .filter-panel {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .filter {
    margin: 0 0.5rem 0.5rem 0;
  }

  /* lead edit grid starts */

  .lead-edit {
    display: grid;
    width: 100vw;
    grid-template-columns: 10% 20% 40% 20% 10%;
    grid-auto-rows: 4% 12% 8% auto;
    grid-template-areas:
      '. . . . .'
      '. title title description .'
      '. profile-info lead-edit-selection-area results .'
      '. . . results .';
    column-gap: 10px;
    row-gap: 10px;
  }

  .lead-edit > .lead-edit-selection-area {
    grid-area: lead-edit-selection-area;
    align-self: start;
  }

  .lead-edit > .results {
    grid-area: results;
  }

  .lead-edit > .profile-information-container {
    grid-area: profile-info;
  }

  .lead-title {
    grid-area: title;
  }

  .lead-edit > .description {
    grid-area: description;
  }

  .lead-edit > #instructions {
    display: grid;
    align-self: self-start;
    grid-area: instructions;
    margin-top: 0;
  }
  /* lead edit ends */


  /* lead search starts*/
  .leads-selections {
    column-gap: 1rem;
    display: grid;
    grid-template-columns: 5% 45% 45% 5%;
    grid-template-rows: auto;
    grid-template-areas:
      '. lead-select lead-link .';
  }

  .leads-selections .guideline {
    display: grid;
    grid-area: lead-select;
    align-items: center;
    font-weight: bold;
  }

  .leads-selections .leads-dropdown {
    grid-area: lead-select;
    padding-top: 1rem;
  }

  .leads-selections .lead-links {
    grid-area: lead-link;
  }

  .leads-columns {
    column-gap: 1rem;
    padding-bottom: 5rem;
    display: grid;
    grid-template-columns: 5% 45% 45% 5%;
    grid-template-rows: auto;
    grid-template-areas:
      '. consultant-skills result-wrapper .';
  }

  .leads-columns .candidate-results-container {
    grid-area: result-wrapper;
  }

  .leads-columns .fill-area-container {
    grid-area: consultant-skills;
    align-content: start;
  }

  /*lead search ends*/

  /* consultant search starts*/
  .consultant-view {
    column-gap: 1rem;
    padding-bottom: 5rem;
    display: grid;
    grid-template-columns: 5% 45% 45% 5%;
    grid-template-rows: auto;
    grid-template-areas:
      '. guideline . . '
      '. consultant-skills result-wrapper .';
  }

  .consultant-view .guideline {
    display: grid;
    grid-area: guideline;
    align-items: center;
  }

  .consultant-view .candidate-results-container {
    grid-area: result-wrapper;
  }

  .consultant-view .fill-area-container {
    grid-area: consultant-skills;
    align-content: start;
  }

    /* consultant search ends*/


  .main-view {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    max-width: 1000px;
    margin: 1rem auto;
    padding: 0 1rem;
  }

  .not-found {
    text-align: left;
    font-size: medium;
  }

  /* This sets margins for all views and implementations EM210531*/
  .selection-area {
    height: fit-content
  }

  .profile-view {
    height: 40rem;
  }

  .skill-level.level--1:hover {
    background-color: #999;
  }

  .skills-view {
    display: grid;
    width: 100vw;
    grid-template-columns: 5% 45% 40% 5%;
    grid-template-rows: 4% auto;
    grid-template-areas:
      '. . . .'
      '. skills-view-selection-area instructions .';

    column-gap: 10px;
    row-gap: 10px;
    padding-bottom: 5rem;
  }

  .skills-view > .selection-area {
    display: grid;
    grid-area: skills-view-selection-area;
    align-self: start;
  }

  .skills-view-infos {
    grid-area: instructions;
    margin-top: 0;
  }

  .skills-view-infos > #instructions {
    display: grid;
    align-self: self-start;
    margin-top: 0;
  }

  .error-message {
    width: 35vw !important;
    margin: 2em auto;
    position: fixed;
    top: unset;
    bottom: 2rem !important;
    right: 5rem !important;
    height: fit-content;
    text-align: left;
  }

  .ui.message p {
   font-size: 0.9rem;
  }

  .status-line {
    display: flex;
    flex-direction: row;
  }

/* Consultant profile */

.consultant-wrapper {
  display: grid;
  grid-template-columns: 5% 25% 50% 20%;
  grid-template-rows: auto auto;
  grid-template-areas:
    '. consultant-title-area  edit-area .'
    '. consultant-info-area consultant-skills-area .';
  column-gap: 10px;
  row-gap: 10px;
  margin-left: 0;
}

.consultant-title {
  grid-area: consultant-title-area;
}

.edit-button {
  grid-area: edit-area;
  width: max-content;
  justify-self: end;
  max-height: max-content;
  align-self: end;
  padding-right: 10px;
  margin: 0px;
}

.edit-button label {
  padding-right: 0.5rem;
}

.consultant-info {
  grid-area: consultant-info-area;
}

.consultant-wrapper .selection-area {
  grid-area: consultant-skills-area;
}

.consultant-info h2 {
  font-size: 1.5rem;
}

}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;;EAEf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;;EAEX,WAAW;;EAEX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;;EAEnB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sDAAsD;;EAEtD,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;;EAEnB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,2CAA2C;EAChE,WAAW;EACX,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;;EAEX,yDAA+C;EAC/C,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;;EAE3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oCAAoC;;AAEpC,YAAY;AACZ;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;;EAEX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sDAAsD;EACtD,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B;;uBAEqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ;;;;wBAIsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;GACG,qBAAqB;GACrB,kBAAkB;GAClB,sCAAsC;AACzC;;AAEA,sBAAsB;AACtB,qDAAqD;AACrD;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,0BAA0B;;EAE1B;IACE,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,8BAA8B;IAC9B;;;;uBAImB;IACnB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mCAAmC;IACnC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;EACA,mBAAmB;;;EAGnB,sBAAsB;EACtB;IACE,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,wBAAwB;IACxB;iCAC6B;EAC/B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,oCAAoC;IACpC,wBAAwB;IACxB;4CACwC;EAC1C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA,mBAAmB;;EAEnB,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,oCAAoC;IACpC,wBAAwB;IACxB;;4CAEwC;EAC1C;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;IAEE,0BAA0B;;;EAG5B;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,gEAAgE;EAChE;IACE;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,2BAA2B;IAC3B;;mDAE+C;;IAE/C,gBAAgB;IAChB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;GACC,iBAAiB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;AAEF,uBAAuB;;AAEvB;EACE,aAAa;EACb,qCAAqC;EACrC,6BAA6B;EAC7B;;qDAEmD;EACnD,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA","sourcesContent":["/* General */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  min-width: 360px;\n  font-family: 'Open Sans';\n}\n\nh1 {\n  font-size: 2rem;\n  margin-top: 2rem !important;\n  padding-right: 0.5rem;\n}\n\nh2 {\n  font-size: 1rem;\n}\n\nh4 {\n  margin-top: 1rem !important;\n}\n\nh5 {\n  font-size: 2.5rem;\n  margin-top: 1rem !important;\n}\n\nul {\n  list-style-type: none;\n  padding-left: 0px\n}\n\nimg {\n  margin: 2rem 0px;\n}\n\n/* Application mobile first */\n\n.app {\n  width: 100%;\n  height: 100%;\n}\n\n#root {\n  position: relative;\n  min-height: 100vh;\n  overflow-x: scroll;\n}\n\n.main-view {\n  min-height: 100%;\n  margin: 1rem 1rem 6rem 1rem;\n}\n\n#content-wrap {\n  width: 100%;\n  padding-bottom: 5rem;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 5rem;\n  z-index: -1;\n  text-align: center;\n  background-color: #eee;\n  padding: 1.8rem;\n}\n\n.error-container {\n  margin: 2rem 2rem;\n}\n\n.header-name {\n  margin-left: 1rem;\n  font-size: x-large;\n}\n\n.header-name-logo-line {\n  display: inline-flex;\n}\n\n.header-pepron-logo {\n  width: 100px;\n  height: auto;\n  margin: 1rem;\n}\n\n.instruction-line {\n  margin: 0.2rem;\n  line-height: 1.5rem;\n}\n\n.layout-content {\n  padding: 0;\n  padding: 1rem 0.5rem 1rem 0.5rem;\n}\n\n.title-new-skill {\n  display: inline-block;\n}\n\n.categories {\n  padding: 3px;\n}\n\n.category {\n  padding: 0;\n  width: 100%;\n  font-size: 1rem;\n  background-color: #eee;\n  border-radius: 5px;\n  margin-bottom: 5px;\n  border: solid 1px #ddd;\n}\n\n.category-content-visible {\n  display: block;\n}\n\n.category-caption {\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: column;\n  color: #161;\n  padding: 0.5rem;\n  background-color: #e8e8e8;\n  /* background-image: linear-gradient(#fff,#ddd); */\n  border-radius: 5px 5px 0 0;\n}\n\n/*  highlight with gradient on category selection */\n.category-caption:hover {\n  color: #0f6901;\n  background-image: linear-gradient(#fff, #fff, #ddd);\n}\n\n.category-nename {\n  flex-grow: 1;\n  width: 50%;\n  user-select: none;\n}\n\n.category-levels {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.category-selected-positioning {\n  align-self: flex-end;\n}\n\n.category-selected-icon {\n  line-height: 1.6rem;\n  height: auto;\n  width: 3rem;\n\n  margin: 2px;\n\n  border: 0px;\n  border-radius: 1rem;\n  border-style: solid;\n\n  font-size: 1rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.9);\n  user-select: none;\n}\n\n.instruction-icon {\n  border-color: #aaa;\n  background-color: #bbb;\n  box-shadow: 0px 5px 0px rgba(255, 255, 255, 0.3) inset;\n\n  line-height: 1rem;\n  width: 1.7rem;\n  margin: 0.2rem;\n  border: 0px;\n  border-radius: 1rem;\n  border-style: solid;\n\n  font-size: 0.7rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.9);\n  user-select: none;\n}\n\n.category-level {\n  display: inline-block;\n}\n\n.category-content-noncollapsed {\n  height: auto;\n}\n\n.category-content-collapsed {\n  height: 0;\n  overflow: hidden;\n}\n\n.header {\n  display: flow-root;\n  position: relative;\n}\n\n.header-menu {\n  width: 100%;\n  margin: 1.5rem 2px 2px 2px;\n}\n\np.find-consultants-grid-description {\n  margin: 1em;\n}\n\n.lead-score-result {\n  overflow-y: scroll; \n  min-height: 300px;\n  height: fit-content;\n  margin-bottom: 1rem;\n  padding: 20px;\n  border: #c6c6c6 solid 1px;\n  border-radius: 2px;\n}\n\n.leads-view {\n  margin: 0.5rem !important;\n}\n\n.leads-view .leads-dropdown {\n  margin-bottom: 1rem;\n}\n\n.leads-selections .lead-links {\n  display: flex;\n  flex-wrap: wrap;\n  margin: auto;\n  align-items: center;\n}\n\n.lead-links a {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n}\n\n.candidate-results-container {\n    margin-bottom: 0.5rem;\n    align-content: start;\n    height: fit-content;\n}\n\n.login-container {\n  width: 50%;\n  height: 50%;\n  margin: auto;\n}\n\n.login-view {\n  flex-direction: column;\n  align-self: center;\n  align-content: center;\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n\n.login-button-container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.no-skill-entries {\n  margin: 1em;\n}\n\n.not-found {\n  text-align: center;\n  margin: 2rem;\n}\n\n/* Profile page */\n\n.profile-view {\n  padding-top: 2rem;\n  display: flex;\n  align-items: start;\n  height: 30rem;\n}\n\n.profile-view > .ui.segment {\n  width: 80%;\n  margin: 0 auto;\n}\n\n.profile-view .ui.header {\n  background-color: white;\n}\n\n.redirecting-spinner {\n  height: 60px;\n}\n\n.score-for {\n  display: flex;\n  padding-bottom: 0.5rem;\n}\n\n.score-for:hover {\n  background-color: rgb(239, 239, 239);\n}\n\n#score-for-list:last-child {\n  margin-bottom: 30px;\n}\n\n.score-for .profile-name {\n  width: 200px;\n}\n\n.score-for-profile-percentage {\n  width: fit-content;\n  min-width: 50px;\n  text-align: center;\n}\n\n.score-for-links {\n  width: 200px;\n  text-align: start;\n  margin-left: 1em;\n}\n\n.signin-button {\n  margin: 2.5rem;\n}\n\n.skill {\n  display: flex;\n  align-items: center; /* This was added for items in the center */\n  color: #000;\n  font-size: 1rem;\n  padding: 0.5rem;\n  background-color: rgba(200, 200, 200, 0);\n  transition: background-color 1s;\n}\n\n.skill:hover {\n  background-image: linear-gradient(#fff, #fff, #ddd);\n}\n\n.skill-name {\n  flex-grow: 1;\n  user-select: none;\n}\n\n.skill-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.error-message {\n  width: 100% !important;\n  z-index: 1000;\n  position: fixed;\n  top: 1rem;\n  height: fit-content;\n}\n\n.personal-preference {\n  margin: 4px 4px 4px 4px;\n  line-height: 2rem;\n}\n\n.star {\n  display: inline-block;\n  height: 1rem;\n  width: 1.7rem;\n  margin: 1px;\n  border: 0px;\n\n  background-image: url('../svg/star_filled.svg');\n  background-size: 1rem;\n  background-repeat: no-repeat;\n  background-position: center;\n\n  opacity: 0.4;\n}\n\n.skills-save {\n  display: block;\n  width: 100%;\n  border-radius: 5px;\n  margin: 1rem 0;\n  padding: 1rem;\n  font-family: 'Open Sans';\n  font-size: 1.5rem;\n  background: #272;\n  color: #fff;\n  border: 0;\n}\n\n.saveskills:hover {\n  background: #161;\n}\n\n.saved {\n  background: #282;\n}\n\n.level--1 {\n  background: #bbb;\n  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5) inset;\n}\n\n.level-0 {\n  background: rgb(92, 92, 92);\n}\n\n.level-1 {\n  background: rgb(0, 40, 0);\n}\n\n.level-2 {\n  background: rgb(14, 79, 10);\n}\n\n.level-3 {\n  background: rgb(34, 119, 34);\n}\n\n.level-4 {\n  background: rgb(20, 149, 14);\n}\n\n.level-5 {\n  background: rgb(5, 187, 5);\n}\n\n.level-loading {\n  background:#e1900d;\n}\n\n/* Colors for partially filled skills */\n.level-0.grayscale {\n  background: rgb(92, 92, 92);\n}\n\n.level-1.grayscale {\n  background: rgb(45, 45, 45);\n}\n\n.level-2.grayscale {\n  background: rgb(68, 68, 68);\n}\n\n.level-3.grayscale {\n  background: rgb(87, 87, 87);\n}\n\n.level-4.grayscale {\n  background: rgb(107, 107, 107);\n}\n\n.level-5.grayscale {\n  background: rgb(139, 139, 139);\n}\n\n/* Overrides for react.semantic-ui */\n\n/* General */\nheader > div.ui.menu {\n  margin: auto 1rem auto 1rem;\n}\n\nbutton.ui.button.skill-level {\n  margin: 2px;\n\n  border: 0px;\n  border-radius: 1rem;\n  border-style: solid;\n  border-color: #fff;\n  box-shadow: 0px 5px 0px rgba(255, 255, 255, 0.3) inset;\n  cursor: pointer;\n  user-select: none;\n}\n\n/*  highlight background on empty selections */\nbutton.ui.button.skill-level.level--1:hover {\n  background-color: rgba(200, 200, 200, 0.5);\n}\n\nbutton.ui.button.skill-level.level--1 {\n  background: #bbb;\n  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5) inset;\n}\n\nbutton.ui.button.skill-level.level-0 {\n  background: rgb(92, 92, 92);\n}\n\nbutton.ui.button.skill-level.level-1 {\n  background: rgb(0, 40, 0);\n}\n\nbutton.ui.button.skill-level.level-2 {\n  background: rgb(14, 79, 10);\n}\n\nbutton.ui.button.skill-level.level-3 {\n  background: rgb(34, 119, 34);\n}\n\nbutton.ui.button.skill-level.level-4 {\n  background: rgb(20, 149, 14);\n}\n\nbutton.ui.button.skill-level.level-5 {\n  background: rgb(5, 187, 5);\n}\n\nbutton.ui.button.skill-level.level-error {\n  background: #9f3a38;\n}\n\nbutton.ui.button.skill-level.level-loading {\n  background: #e1900d;\n}\n\ndiv.ui.error.message.errorStatus {\n  min-height: 150px;\n  margin-top: 2em;\n  padding: 2em;\n}\n\n.header .ui.dimmer {\n  display: inline-block;\n  z-index: 1000;\n  position: fixed !important;\n  /* left: 58% !important; */\n  top: 20% !important;\n  width: 100%;\n  height: 80px;\n  justify-items: end;\n  background-color: #3f5d5172;\n}\n\n.header .ui.dimmer .ui.loader {\n  align-content: space-around !important;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.header .ui.dimmer .ui.loader:after {\n  border-color: rgba(25, 255, 25, 0.695) transparent transparent;\n}\n\n.ui.segment.instructions {\n  font-size: 0.8rem;\n  padding: 1rem;\n  margin: 1rem 0.5rem 1rem 0.5rem;\n  background-color: #fff;\n  border: solid 1px #ddd;\n}\n\n.ui.button.dropdown {\n height: 2.5rem;\n}\n\ni.help {\n margin: 0px;\n}\n\n.filter-interactables {\n  min-width: 140px;\n  display: grid;\n  grid-template-columns: 40% 60%;\n  grid-template-rows: 40% auto;\n  grid-template-areas:\n    'checkbox subtitle'\n    'dropdown dropdown';\n  padding-bottom: 1rem;\n  row-gap: 0.3rem;\n}\n\n.filter-interactables > .ui.fitter.toggle.checkbox {\n  grid-area: checkbox;\n}\n\n.filter-interactables > .subtitle {\n  grid-area: subtitle;\n}\n\n.filter-interactables > .dropdown {\n  grid-area: dropdown;\n}\n\n.header-button-line {\n  position: absolute;\n  top: 1.5rem;\n  right: 1rem;\n  height: fit-content;\n  text-align: left;\n}\n\n.ui.button.logout-button {\n  display: inline-block;\n  text-align: left;\n  margin-left: 1rem;\n  height: 3rem;\n  /* padding: 10px 10px;\n  border-style: solid;\n  border-color: rgb(122, 122, 122);\n  border-width: 1px;\n  border-radius: 3px;  */\n}\n\n.help-button {\n  padding: 11px 10px;\n  text-align:  center;\n  border-style: solid;\n  border-color: rgb(122, 122, 122);\n  border-width: 1px;\n  border-radius: 3px;\n}\n\n/* Consultant profile*/\n.consultant-wrapper {\n  height: fit-content;\n  margin-bottom: 30px;\n}\n\n.consultant-info {\n  margin-left: 2rem;\n  margin-bottom: 1rem;\n}\n\n.consultant-title {\n  margin-left: 2rem;\n  padding-top: 1rem;\n}\n\n.consultant-view .guideline {\n  align-items: center;\n  font-weight: bold;\n  margin: 1rem;\n}\n\n.edit-button {\n  width: max-content;\n  max-height: max-content;\n  margin: 1rem 0 0.5rem 1rem;\n}\n\n.edit-button .ui.active.button {\n  box-shadow: 5px 5px 7px  #3b4532a5 !important;\n}\n\n.edit-mode {\n   border-color: #c6c6c6;\n   border-radius: 3px;\n   box-shadow: 7px 7px 12px 7px #3b4532a5;\n}\n\n/* Screens overrides */\n/* All mediatypes and if screen is wider than 985px */\n@media all and (min-width: 985px) {\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    align-content: center;\n    width: 100%;\n    height: auto;\n    text-align: left;\n    vertical-align: middle;\n    background-color: #eee;\n    padding: 2rem;\n  }\n\n  .header-interactables {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .header-menu {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin: auto;\n  }\n\n  .header-name {\n    margin: auto 2rem auto 0;\n    font-size: x-large;\n  }\n\n  .header-button-line {\n    top: 3rem;\n  }\n\n  .content-list {\n    padding-inline-start: 0;\n  }\n\n  .category-caption {\n    cursor: pointer;\n  }\n\n  .filter-panel {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .filter {\n    margin: 0 0.5rem 0.5rem 0;\n  }\n\n  /* lead edit grid starts */\n\n  .lead-edit {\n    display: grid;\n    width: 100vw;\n    grid-template-columns: 10% 20% 40% 20% 10%;\n    grid-auto-rows: 4% 12% 8% auto;\n    grid-template-areas:\n      '. . . . .'\n      '. title title description .'\n      '. profile-info lead-edit-selection-area results .'\n      '. . . results .';\n    column-gap: 10px;\n    row-gap: 10px;\n  }\n\n  .lead-edit > .lead-edit-selection-area {\n    grid-area: lead-edit-selection-area;\n    align-self: start;\n  }\n\n  .lead-edit > .results {\n    grid-area: results;\n  }\n\n  .lead-edit > .profile-information-container {\n    grid-area: profile-info;\n  }\n\n  .lead-title {\n    grid-area: title;\n  }\n\n  .lead-edit > .description {\n    grid-area: description;\n  }\n\n  .lead-edit > #instructions {\n    display: grid;\n    align-self: self-start;\n    grid-area: instructions;\n    margin-top: 0;\n  }\n  /* lead edit ends */\n\n\n  /* lead search starts*/\n  .leads-selections {\n    column-gap: 1rem;\n    display: grid;\n    grid-template-columns: 5% 45% 45% 5%;\n    grid-template-rows: auto;\n    grid-template-areas:\n      '. lead-select lead-link .';\n  }\n\n  .leads-selections .guideline {\n    display: grid;\n    grid-area: lead-select;\n    align-items: center;\n    font-weight: bold;\n  }\n\n  .leads-selections .leads-dropdown {\n    grid-area: lead-select;\n    padding-top: 1rem;\n  }\n\n  .leads-selections .lead-links {\n    grid-area: lead-link;\n  }\n\n  .leads-columns {\n    column-gap: 1rem;\n    padding-bottom: 5rem;\n    display: grid;\n    grid-template-columns: 5% 45% 45% 5%;\n    grid-template-rows: auto;\n    grid-template-areas:\n      '. consultant-skills result-wrapper .';\n  }\n\n  .leads-columns .candidate-results-container {\n    grid-area: result-wrapper;\n  }\n\n  .leads-columns .fill-area-container {\n    grid-area: consultant-skills;\n    align-content: start;\n  }\n\n  /*lead search ends*/\n\n  /* consultant search starts*/\n  .consultant-view {\n    column-gap: 1rem;\n    padding-bottom: 5rem;\n    display: grid;\n    grid-template-columns: 5% 45% 45% 5%;\n    grid-template-rows: auto;\n    grid-template-areas:\n      '. guideline . . '\n      '. consultant-skills result-wrapper .';\n  }\n\n  .consultant-view .guideline {\n    display: grid;\n    grid-area: guideline;\n    align-items: center;\n  }\n\n  .consultant-view .candidate-results-container {\n    grid-area: result-wrapper;\n  }\n\n  .consultant-view .fill-area-container {\n    grid-area: consultant-skills;\n    align-content: start;\n  }\n\n    /* consultant search ends*/\n\n\n  .main-view {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    max-width: 1000px;\n    margin: 1rem auto;\n    padding: 0 1rem;\n  }\n\n  .not-found {\n    text-align: left;\n    font-size: medium;\n  }\n\n  /* This sets margins for all views and implementations EM210531*/\n  .selection-area {\n    height: fit-content\n  }\n\n  .profile-view {\n    height: 40rem;\n  }\n\n  .skill-level.level--1:hover {\n    background-color: #999;\n  }\n\n  .skills-view {\n    display: grid;\n    width: 100vw;\n    grid-template-columns: 5% 45% 40% 5%;\n    grid-template-rows: 4% auto;\n    grid-template-areas:\n      '. . . .'\n      '. skills-view-selection-area instructions .';\n\n    column-gap: 10px;\n    row-gap: 10px;\n    padding-bottom: 5rem;\n  }\n\n  .skills-view > .selection-area {\n    display: grid;\n    grid-area: skills-view-selection-area;\n    align-self: start;\n  }\n\n  .skills-view-infos {\n    grid-area: instructions;\n    margin-top: 0;\n  }\n\n  .skills-view-infos > #instructions {\n    display: grid;\n    align-self: self-start;\n    margin-top: 0;\n  }\n\n  .error-message {\n    width: 35vw !important;\n    margin: 2em auto;\n    position: fixed;\n    top: unset;\n    bottom: 2rem !important;\n    right: 5rem !important;\n    height: fit-content;\n    text-align: left;\n  }\n\n  .ui.message p {\n   font-size: 0.9rem;\n  }\n\n  .status-line {\n    display: flex;\n    flex-direction: row;\n  }\n\n/* Consultant profile */\n\n.consultant-wrapper {\n  display: grid;\n  grid-template-columns: 5% 25% 50% 20%;\n  grid-template-rows: auto auto;\n  grid-template-areas:\n    '. consultant-title-area  edit-area .'\n    '. consultant-info-area consultant-skills-area .';\n  column-gap: 10px;\n  row-gap: 10px;\n  margin-left: 0;\n}\n\n.consultant-title {\n  grid-area: consultant-title-area;\n}\n\n.edit-button {\n  grid-area: edit-area;\n  width: max-content;\n  justify-self: end;\n  max-height: max-content;\n  align-self: end;\n  padding-right: 10px;\n  margin: 0px;\n}\n\n.edit-button label {\n  padding-right: 0.5rem;\n}\n\n.consultant-info {\n  grid-area: consultant-info-area;\n}\n\n.consultant-wrapper .selection-area {\n  grid-area: consultant-skills-area;\n}\n\n.consultant-info h2 {\n  font-size: 1.5rem;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
